//
//
//
//
//
//
//


    import Vue from "vue"

    
    
let _i18n_vue = new Vue()
// eslint-disable-next-line no-unused-vars
const $t = _i18n_vue.$t.bind(_i18n_vue)
// 设置菜单
const setMenu = editor => {
  editor.config.menus = [
    "head", // 标题
    "bold", // 粗体
    "fontSize", // 字号
    "fontName", // 字体
    "justify", // 对齐方式
    "italic", // 斜体
    "underline", // 下划线
    "strikeThrough", // 删除线
    "foreColor", // 文字颜色
    "backColor", // 背景颜色
    "quote", // 引用
    "table", // 表格
    "link",
    "list",
    "emoticon",
    "image",
    "video",
    "code",
    "splitLine",
    "undo",
    "redo"
  ]
}

// 设置颜色（文字颜色/背景色）
const setColor = editor => {
  editor.config.colors = [
    "#000000",
    "#ffffff",
    "#417BDE",
    "#72C040",
    "#F1B82B",
    "#EC5B57",
    "#616E80",
    "#0D1726",
    "#36404F",
    "#616E80",
    "#B8C1D0",
    "#DAE2EE",
    "#EEF1F9",
    "#9FA9B9",
    "#252E3B",
    "#364F74",
    "#C55253",
    "#1698AF",
    "#5687D9",
    "#DDAC67"
  ]
}

// 设置其他配置信息
const setConfig = (editor, vm) => {
  editor.config.placeholder = vm.placeholder
  editor.config.focus = vm.focus
  editor.config.zIndex = 500

  // http://www.wangeditor.com/doc/pages/06-%E7%B2%98%E8%B4%B4%E8%BF%87%E6%BB%A4/01-%E5%85%B3%E9%97%AD%E5%AF%B9%E7%B2%98%E8%B4%B4%E5%86%85%E5%AE%B9%E6%A0%B7%E5%BC%8F%E7%9A%84%E8%BF%87%E6%BB%A4.html
  if (vm.parsedStyle) {
    editor.config.pasteFilterStyle = false
  }
}

// 监听编辑器内容变化
const watchEditor = (editor, vm) => {
  editor.config.onchange = html => {
    vm.$emit("voc-editor-value-changed", html, editor)
  }
}

// 编辑区域失去失去焦点
const onEditorBlur = (editor, vm) => {
  editor.config.onblur = html => {
    vm.$emit("voc-editor-blured", html)
  }
}

export default {
  name: "VocEditor",
  props: {
    placeholder: {
      type: String,
      default: $t("b1b93a04399891da")
    },
    // 富文本内容
    hContent: {
      type: String,
      default: ""
    },
    // 是否保留复制文本的样式
    parsedStyle: {
      type: Boolean,
      default: true
    },
    // 自动 focus
    focus: {
      type: Boolean,
      default: true
    }
  },
  watch: {
    hContent(newVal) {
      if (this.editorInstance) {
        this.editorInstance.txt.html(newVal)
      }
    }
  },
  data() {
    return {
      editorInstance: null
    }
  },
  mounted() {
    if (window.wangEditor) {
      const Editor = window.wangEditor
      // 初始化
      this.editorInstance = new Editor(this.$refs["ref-toolbar"], this.$refs["ref-editor"])
      // 配置
      setMenu(this.editorInstance)
      setColor(this.editorInstance)
      setConfig(this.editorInstance, this)
      watchEditor(this.editorInstance, this)
      onEditorBlur(this.editorInstance, this)
      this.editorInstance.create()
      this.editorInstance.txt.html(this.hContent)
    }
  },
  beforeDestroy() {
    // 销毁编辑器
    this.editorInstance.destroy()
    this.editorInstance = null
  }
}
